import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import CircleIcon from '@mui/icons-material/Circle';
import { styled } from '@mui/material/styles';



const TextStyled = styled('ListItemText')(({ theme }) => ({
    fontFamily: 'Inter',
    color: 'common.black'
  }));

const TextMicroOverview = () => {

return(
<div>

<Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Introduction </Typography>
<br /><br />

<Box >
<List sx={{ fontFamily: 'Inter', color: 'common.black'}}>

<ListItem>
<ListItemIcon><CircleIcon fontSize = "small" color= "primary.dark" /></ListItemIcon>
<TextStyled> The human microbiome is a very diverse assembly of microbial species which makes a singular functional unit (sometimes termed ‘metabolic organ’).</TextStyled>
</ListItem>

<ListItem>
<ListItemIcon><CircleIcon fontSize = "small" color= "primary.dark" /></ListItemIcon>
<TextStyled>The gastrointestinal tract harbors a complex community of over 100 trillion microbial cells that influence human physiology, metabolism, nutrition, and immune function.</TextStyled>
</ListItem>

<ListItem>
<ListItemIcon><CircleIcon fontSize = "small" color= "primary.dark" /></ListItemIcon>
<TextStyled>The gut microbiota can exert healthy benefits as well as pathological effects on human health.</TextStyled>
</ListItem>

<ListItem>
<ListItemIcon><CircleIcon fontSize = "small" color= "primary.dark" /></ListItemIcon>
<TextStyled>Physiological functions of the microbiota include metabolism of food, fermentation of indigestible food, synthesis of vitamins, and forming an epithelial barrier and barricade against pathogenic bacteria.</TextStyled>
</ListItem>

<ListItem>
<ListItemIcon><CircleIcon fontSize = "small" color= "primary.dark" /></ListItemIcon>
<TextStyled>Dysbiosis, a term referring to changes in the composition of the microbiota and its metabolites has been suggested to play a pivotal role in propagating inflammatory and metabolic diseases including gastrointestinal disorders, cancers, cardiovascular disease (CVD), atherosclerosis, hypertension, kidney disease, heart disease, obesity, type 2 diabetes mellitus, and inflammatory bowel disease.</TextStyled>
</ListItem>

</List>
</Box>


<br /><br />
The microbiome is the collection of all microbes, such as bacteria, fungi, viruses, and their genes, that naturally live on our bodies and inside us. 
Although microbes are so small that they require a microscope to see them, they contribute in big ways to human health and wellness. 
They protect us against pathogens, help our immune system develop, and enable us to digest food to produce energy.<br /><br />

Because the microbiome is a key interface between the body and the environment, these microbes can affect health in many ways and can even affect 
how we respond to certain environmental substances. Some microbes alter environmental substances in ways that make them more toxic, while others act as a 
buffer and make environmental substances less harmful.<br /><br />

A person’s core microbiome is formed in the first years of life but can change over time in response to different factors including diet, medications, and environmental exposures.

<br /><br />

Differences in the microbiome may lead to different health effects from environmental exposures and may also help determine individual susceptibility to certain illnesses. 
Environmental exposures can also disrupt a person’s microbiome in ways that could increase the likelihood of developing conditions such as diabetes, obesity, 
cardiovascular and neurological diseases, allergies, and inflammatory bowel disease. For example, specific changes in the gut microbiome have been linked to liver health. 
<br /><br />

<Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Microbiome & Cardiovascular Diseases: </Typography>
<br /><br />

Dysbiosis increases the risk for various CVDs through several
mechanisms. It is associated with microbial translocation from the
gut into the interstitium and perivascular tissues resulting in
systemic inflammation, abnormalities of lipid and glucose metabolism,
atherosclerosis, and hypertension. Western diet and timing
of feeding contribute to the risk for CVD by modulating the gut
microbiota. <br /><br />

High dietary salt intake contributes to dysbiosis and
development of hypertension and increases the risk for various
CVDs. Sex-dependent microbial composition is emerging as one of
the risk factors for CVD. However, there is still scarcity of data on
this subject and it warrants further investigation. Aging is
associated with a decline in health-promoting bacteria species
and with enhancement of metabolic pathways that lead to
cardiovascular disease. <br /><br />
Thus, the gut microbiota is intricately
involved in various CVDs. Understanding this relationship is critical
for future targeted therapy to prevent and improve CVDs and to
ameliorate cardiovascular adverse events. Quantification of TMAOs
is an important marker for prognosis of certain cardiovascular
events such as stroke, heart attack and death. Use of pre- and
probiotics and TMAO inhibitors, has great potential for future
therapy in managing CVDs.

</div>
)
}

export default TextMicroOverview;